import { useNavigate } from "react-router-dom";
import { dropdownIcon } from "../../../utility-functions/assetLoader";
import { playButtonIcon } from "../../../utility-functions/assetLoader";
import GModal from "./GModal";
import "./customComponents.css";
import { useState, useRef } from "react";
import Button from "../Button";
import { ExpandMore, Visibility, VisibilityOff } from "@mui/icons-material";
import { useEffect } from "react";
import searchIcon from "../../../assets/SearchIcon.svg";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { Chip } from "@mui/material";
import AnimationPage from "../../shared/animation-page/AnimationPage";
import { topNavAccountSelectedAccountTickIcon } from "../../../utility-functions/assetLoader";
import commonStyles from "../commonStyles";
import { MenuItem, Select, Avatar } from "@mui/material";
import colors from "../colors";
import chipDeleteIcon from "../../../assets/gusers-and-teams-chip-delete-icon.svg";
import styles from "../styles";
import { Paper, InputBase } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import AddIcon from "@mui/icons-material/Add";
import ChevronDown from "../../../assets/gusers-and-teams-down-arrow.svg";
export const CustomInput = ({
  value,
  handleChange,
  handleFocus,
  label,
  CustomError,
  name,
  type,
  children,
  style,
  disabled,
  inputProps,
  inputContainerStyle,
  ...props
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <label
      className="medium-font t7 textfield-label"
      style={{ ...style, ...props.labelStyles }}
    >
      {label}
      <div
        className={`${props.dropdown ? "phone-number" : ""}`}
        style={{ position: "relative", ...inputContainerStyle }}
      >
        {props?.dropdown && props.dropdown}
        <input
          placeholder={props.placeholder}
          onFocus={handleFocus}
          onBlur={props?.handleBlur}
          className={`regular-font t7 ${value?.error ? "input-error" : ""}`}
          name={name}
          type={showPassword ? "text" : type}
          value={value?.value || ""}
          onChange={handleChange}
          style={style}
          disabled={disabled}
          {...inputProps}
        />
        {CustomError && <span className="error-message">{CustomError}</span>}
        {type === "password" && value.value && (
          <span
            style={{
              position: "absolute",
              top: "55%",
              transform: "translateY(-50%)",
              right: "8px",
              cursor: "pointer",
            }}
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </span>
        )}
      </div>
      {typeof value?.error === "string" &&
        value.error.trim() !== "" &&
        value?.error && (
          <p style={props.errorStyle} className="t7 regular-font">
            {value.error}
          </p>
        )}
      {children}
    </label>
  );
};

export function CustomSearchableDropdown({
  label = "Select an option",
  placeholder = "Search...",
  options = [],
  selectedId = "",
  onDropdownOpen = () => {},
  onDropdownClose = () => {},
  onSelect = () => {},
  searchable = true,
  width = "200px",
  align = "start",
  paperWidth = "100%",
  disabled = false,
  onSearch = () => {},
  disableSelectForSelected = false,
  renderContainerStyleOverride = {},
  unselectedStyle = {},
}) {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const wrapperRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filtered = searchable
    ? options.filter((item) =>
        item.name.toLowerCase().includes(searchTerm.toLowerCase())
      )
    : options;

  function handleSelectOption(id) {
    onSelect(id);
    setOpen(false);
    onDropdownClose();
    setSearchTerm("");
  }

  return (
    <div ref={wrapperRef} style={{ position: "relative", width }}>
      <style>{`
         ::-webkit-scrollbar {
          width: 6px;
        }
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
        .custom-input {
          padding-top: 0px !important;
          padding-bottom: 0px !important;
          padding-left: 0px !important;
          border: none !important;
          margin-top: 0 !important;
          color: #3F3F46 !important;
          font-weight: 400 !important;
        }
      `}</style>

      <Paper
        variant="outlined"
        style={{
          padding: "8px",
          cursor: disabled ? "not-allowed" : "pointer",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderColor: open ? "#36cb64" : "#E4E4E7",
          boxShadow: open ? "0 0 8px rgba(54, 203, 100, 0.5)" : "none",
          transition: "border-color 0.3s, box-shadow 0.3s",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
          ...renderContainerStyleOverride,
        }}
        onClick={() => {
          if (!disabled) {
            const newState = !open;
            setOpen(newState);
            newState ? onDropdownOpen() : onDropdownClose();
          }
        }}
      >
        <div
          style={{
            color: selectedId ? "#3F3F46" : "var(--grey-400)",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontWeight: "400",
            whiteSpace: "nowrap",
            ...unselectedStyle,
          }}
        >
          {selectedId
            ? options.find((o) => o.id === selectedId)?.name || label
            : label}
        </div>
        <img
          src={ChevronDown}
          alt="Chevron Down Icon"
          style={{
            width: "16px",
            height: "16px",
            filter:
              "invert(42%) sepia(3%) saturate(186%) hue-rotate(180deg) brightness(97%) contrast(93%)",
          }}
        />
      </Paper>

      {open && (
        <Paper
          style={{
            position: "absolute",
            zIndex: 9999,
            width: paperWidth,
            marginTop: "8px",
            maxHeight: "200px",
            overflowY: "auto",
            border: "1px solid #E4E4E7",
            borderRadius: "6px",
            [align === "end" ? "right" : "left"]: 0,
          }}
        >
          {searchable && (
            <>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  margin: "12px",
                  border: "1px solid #E4E4E7",
                  borderRadius: "6px",
                }}
              >
                <img
                  src={searchIcon}
                  alt="Search Icon"
                  style={{
                    marginRight: "8px",
                    width: "20px",
                    height: "20px",
                    filter:
                      "invert(42%) sepia(3%) saturate(186%) hue-rotate(180deg) brightness(97%) contrast(93%)",
                  }}
                />
                <InputBase
                  placeholder={placeholder}
                  value={searchTerm}
                  onChange={(e) => {
                    const v = e.target.value;
                    setSearchTerm(v);
                    onSearch(v);
                  }}
                  style={{ flex: 1, color: "#3F3F46", fontWeight: "400" }}
                  inputProps={{
                    className: "custom-input",
                  }}
                />
              </div>
              <div style={{ borderTop: "1px solid #eee" }} />
            </>
          )}
          {filtered.map((item) => {
            const textStyle = {
              fontSize: "14px",
              color: item.style?.color || "#3F3F46",
              fontWeight: "400",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              width: "100%",
            };
            return (
              <div
                key={item.id}
                style={{
                  padding: "0 16px",
                  height: "44px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  backgroundColor: selectedId === item.id ? "#F0FCF4" : "white",
                  pointerEvents: disableSelectForSelected
                    ? selectedId === item.id
                      ? "none"
                      : "all"
                    : "all",
                }}
                onClick={() => handleSelectOption(item.id)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                  }}
                >
                  {item.id === "new" && (
                    <AddIcon
                      style={{
                        marginRight: "8px",
                        color: item.style?.color || "#3F3F46",
                      }}
                    />
                  )}
                  <div style={textStyle}>{item.name}</div>
                </div>
                {selectedId === item.id && (
                  <CheckIcon style={{ fontSize: "small" }} />
                )}
              </div>
            );
          })}
          {filtered.length === 0 && (
            <div style={{ padding: "0 16px", height: "44px" }}>
              <div style={{ fontSize: "14px", color: "#888" }}>
                No results found.
              </div>
            </div>
          )}
        </Paper>
      )}
    </div>
  );
}

export const CCDropdown = ({
  handleCountrySelect,
  selectedCountryCode,
  CCDropdownstyle,
  disabled = false,
}) => {
  const [ccData, setCCData] = useState([]);
  const [searchedCountryCode, setSearchedCountryCode] = useState("");
  const [countryCodeList, setCountryCodeList] = useState([]);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  useEffect(() => {
    fetchCountries();
  }, []);

  const fetchCountries = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BETA + "/api/v1/auth/locations/"
      );
      const data = await response.json();
      setCCData(data);
      setCountryCodeList(data);
    } catch (error) {
      console.error("Error fetching countries:", error);
    }
  };

  function handleCCSearchChange(e) {
    const search = e.target.value;
    setSearchedCountryCode(search);
    // filter from ccData and update ccList
    if (!search || search?.trim()?.length === 0) {
      setCountryCodeList(ccData);
      return;
    }
    const lowercaseSearch = search.toLowerCase();
    const temp = ccData.filter(
      (cc) =>
        `${cc.country.toLowerCase()} +${cc.country_code} ${cc.iso_code.toLowerCase()}`.includes(
          lowercaseSearch
        ) || lowercaseSearch.includes(cc.iso_code.toLowerCase())
    );
    setCountryCodeList(temp);
  }

  const handleCountryCodeSelect = (countryCode) => () => {
    handleCountrySelect(countryCode);
    setDropdownVisible(false);
  };

  const uniqueCountryCodes = [
    ...new Set(countryCodeList.map((cc) => cc.country_code)),
  ];

  return (
    <>
      <div
        className="cc-container t7 regular-font"
        onClick={() => (disabled ? null : setDropdownVisible((prev) => !prev))}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
          color: disabled ? colors.nc_gray_600 : colors.nc_gray_900,
        }}
      >
        {selectedCountryCode}
        <span
          style={{
            transform: dropdownVisible ? "rotate(180deg)" : "rotate(0deg)",
          }}
        >
          {dropdownIcon()}
        </span>
      </div>
      {dropdownVisible && (
        <div className="dialer--cc_dropdown_container cc-dropdown">
          <div className="dialer--cc_search">
            <img src={searchIcon} alt="" />
            <input
              style={CCDropdownstyle}
              type="search"
              value={searchedCountryCode}
              onChange={handleCCSearchChange}
              placeholder="Search"
              title="Enter country name to search"
              disabled={!ccData.length}
            />
          </div>
          <ul className="dialer--cc_options">
            {ccData.length > 0 ? (
              uniqueCountryCodes.map((countryCode) => {
                const ccObj = countryCodeList.find(
                  (cc) => cc.country_code === countryCode
                );
                return (
                  <li
                    key={ccObj.id}
                    value={ccObj.country_code}
                    onClick={handleCountryCodeSelect(ccObj.country_code)}
                    style={{
                      backgroundColor:
                        selectedCountryCode === ccObj.country_code
                          ? "#f0fcf4"
                          : "",
                    }}
                  >
                    <div>
                      <span
                        className={
                          selectedCountryCode === ccObj.country
                            ? "dialer--cc_name"
                            : ""
                        }
                      >
                        {`${ccObj.country} (${ccObj.country_code})`}
                      </span>
                    </div>
                    {selectedCountryCode === ccObj.country_code && (
                      <span style={{ float: "right" }}>
                        {topNavAccountSelectedAccountTickIcon()}
                      </span>
                    )}
                  </li>
                );
              })
            ) : (
              <AnimationPage />
            )}
          </ul>
        </div>
      )}
    </>
  );
};

export const CustomSwitch = ({
  checked,
  onChange,
  label,
  description,
  labelStyles = {},
  switchMT = 0,
  ...props
}) => {
  return (
    <div className="switch--container" style={{ marginTop: `${switchMT}px` }}>
      <div className="switch custom-switch">
        <label>
          <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            style={{ cursor: "pointer", marginTop: "0" }}
            name={props.name}
          />
          <span className="slider round"></span>
        </label>
      </div>
      <div>
        <p className="t7 regular-font">{label}</p>
        {description && (
          <p
            className="t7 regular-font nc-gray-600"
            style={{ marginTop: "2px" }}
          >
            {description}
          </p>
        )}
      </div>
    </div>
  );
};

const PaymentReminderCard = ({ planName, dueDate, onPayNow }) => {
  return (
    <div
      style={{
        border: "1px solid #E0544C",
        borderRadius: "8px",
        padding: "16px",
        maxWidth: "748px",
        backgroundColor: "#fff",
        color: "#464D48",
      }}
    >
      <p
        style={{
          fontSize: "16px",
          fontWeight: "600px",
          color: "#464D48",
          marginBottom: "10px",
        }}
      >
        Action Required: Complete Payment
      </p>
      <p style={{ fontSize: "16px", lineHeight: "2", fontWeight: "400" }}>
        Your payment for the <span>{planName}</span> is due.
      </p>
      <p style={{ fontSize: "16px", lineHeight: "1", marginBottom: "24px" }}>
        To maintain uninterrupted access to all features, please complete your
        payment by <span>{dueDate}</span>.
      </p>
      <div style={{ textAlign: "right" }}>
        <Button
          hierarchy="green"
          buttonText="Pay now"
          onClick={onPayNow}
          styleOverride={{
            height: "36px",
            fontSize: "14px",
            lineHeight: "14px",
            fontWeight: "400",
            padding: "10px 16px",
          }}
        />
      </div>
    </div>
  );
};

export default PaymentReminderCard;

export const VideoLinkModal = ({
  visible,
  handleClose,
  heading,
  text,
  url,
  ...props
}) => {
  return (
    <GModal
      visible={visible}
      closeModal={handleClose}
      bottomButtons={[]}
      heading={heading}
      headingStyle={{
        backgroundColor: "#fff",
        borderBottom: "none",
        marginLeft: "25%",
        paddingTop: "8px",
        ...props.headingStyle,
      }}
      modalStyle={{ paddingTop: "0px" }}
      bodyWrapperStyle={{ maxWidth: "448px" }}
      body={
        <div>
          <p
            className="t7 regular-font"
            style={{
              textAlign: "center",
              margin: "8px auto 16px",
              color: "#000",
              lineHeight: "180%",
            }}
          >
            {text}
          </p>
          <div
            style={{
              borderRadius: "10px",
              background: "#CAFCDA",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: "413px",
              width: "400px",
            }}
          >
            <a href={url || ""}>
              <span>{playButtonIcon()}</span>
            </a>
          </div>
        </div>
      }
    />
  );
};

export const InsufficientCreditsModal = ({
  visible,
  handleClose,
  handlePayWithCard,
  handleAddCredits,
}) => {
  const navigate = useNavigate();
  const handleNavigateToCredits = () => {
    handleClose();
    navigate("/billing", { state: { tab: "Credits" } });
  };
  return (
    <GModal
      heading="Insufficient credits"
      visible={visible}
      closeModal={handleClose}
      bottomButtons={[
        <Button
          styleOverride={btnStyle}
          hierarchy="green"
          buttonText="Pay with card"
          onClick={handlePayWithCard}
          disabled={false}
        />,
        <Button
          styleOverride={btnStyle}
          hierarchy="green"
          buttonText="Add credits"
          onClick={handleAddCredits || handleNavigateToCredits}
          disabled={false}
        />,
      ]}
      body={
        <p className="t7 regular-font">
          Add account credits or pay with Debit/Credit card.
        </p>
      }
      modalStyle={{ width: "430px", minHeight: "auto", padding: "32px" }}
      bottomButtonsStyle={{ borderTop: "none", paddingTop: "8px" }}
      bodyWrapperStyle={{ paddingRight: 0 }}
    />
  );
};

export const PaymentMethodModal = ({
  visible,
  handleClose,
  handlePayWithCard,
  handlePayWithCredits,
}) => {
  return (
    <GModal
      heading="Select payment method"
      visible={visible}
      closeModal={handleClose}
      bottomButtons={[
        <Button
          styleOverride={btnStyle}
          hierarchy="white"
          buttonText="Pay with credits"
          onClick={handlePayWithCredits}
          disabled={false}
        />,
        <Button
          styleOverride={btnStyle}
          hierarchy="green"
          buttonText="Pay with card"
          onClick={handlePayWithCard}
          disabled={false}
        />,
      ]}
      body={
        <p className="t7 regular-font">
          Pay using account credits or Debit/Credit card.
        </p>
      }
      modalStyle={{ width: "430px", minHeight: "auto", padding: "32px" }}
      bottomButtonsStyle={{ borderTop: "none", paddingTop: "8px" }}
      bodyWrapperStyle={{ paddingRight: 0 }}
    />
  );
};
/**
 *
 * @param {string} 		  				              label
 * @param {Boolean} 		  			              disabled
 * @param {object} 			  		  	            value
 * @param {Function}   			                  handleChange
 * @param {object}             			          defaultValue
 * @param {string}   					                renderVal
 * @param {array}						                  options
 * @param {StyleSheet}					              labelStyles
 * @param {StyleSheet}                        selectStyles
 * @returns {import('react').ReactNode}				reusable select component.
 */

export const CustomSelect = ({
  label = "",
  disabled = false,
  value,
  handleChange = () => null,
  defaultValue = "Select",
  renderVal,
  options,
  disableOption = () => false,
  labelStyles = {},
  selectStyles,
  defaultValStyles,
  extraOptions,
  noOptionText = "No option available",
  ...props
}) => {
  const isSelected = (selected, value) =>
    value !== null &&
    (typeof value === "object"
      ? value?.id === selected?.id
      : value === selected);
  return (
    <>
      {label && 
        <label
          className="t7 nc-gray-900 medium-font"
          style={{ marginBottom: "4px", ...labelStyles }}
        >
          {label}
        </label>
      }
      <Select
        disabled={disabled}
        name={props.name}
        value={value}
        IconComponent={ExpandMore}
        onChange={handleChange}
        sx={{ ...commonStyles.select, ...selectStyles, cursor: disabled ? "not-allowed" : "pointer",
          "& .MuiSelect-select": {
            cursor: disabled ? "not-allowed" : "pointer",
          }, }}
        displayEmpty
        inputProps={{ "aria-label": "Without label", style: { cursor: disabled ? "not-allowed" : "pointer" } }}
        MenuProps={{
          sx: {
            maxHeight: "300px",
            "& .MuiPaper-root": {
              ...(props.menuWidth ? { width: props.menuWidth } : {}),
            },
            ...localStyles.scrollbar,
          },
        }}
        renderValue={
          typeof renderVal === "function"
            ? renderVal
            : (selected) => {
                if (!selected) {
                  return (
                    <p
                      style={{ ...defaultValStyles, color: "#A0A0AB", }}
                      className="t7 regular-font nc-gray-400 render-value-no-overflow"
                    >
                      {defaultValue}
                    </p>
                  );
                } else {
                  return (
                    <p className="t7 regular-font render-value-no-overflow">
                      {renderVal
                        ? selected[renderVal]
                        : (options?.find((elem) => elem.value === selected)
                            ?.displayValue ?? selected)}
                    </p>
                  );
                }
              }
        }
      >
        {options?.map((opt) => (
          <MenuItem
            value={opt.value}
            key={
              opt.value
                ? typeof opt.value === "object"
                  ? opt.value?.id
                  : opt.value
                : opt.displayValue
            }
            sx={{
              ...commonStyles.menu_item,
              backgroundColor: isSelected(value, opt.value)
                ? colors.ic_green_100
                : `${colors.ic_white} !important`,
              "&:hover": {
                backgroundColor: isSelected(value, opt.value)
                  ? "#F1FCF4 !important"
                  : `#FAFAFA !important`,
              },
              whiteSpace: "normal",
            }}
            disabled={opt.value === null || disableOption(opt)}
          >
            <span>{opt.displayValue}</span>
            <span>
              {isSelected(value, opt.value) &&
                topNavAccountSelectedAccountTickIcon()}
            </span>
          </MenuItem>
        ))}
        {extraOptions && extraOptions.map((opt) => opt)}
        {(!options || !options.length) &&
          (!extraOptions || !extraOptions.length) && (
            <MenuItem disabled>{noOptionText}</MenuItem>
          )}
      </Select>
    </>
  );
};

const BootstrapTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#FFFFFF",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#FFFFFF",
    color: "#3f3f46",
    boxShadow: `0px 12px 16px -4px #10182814`,
    padding: "12px",
    fontSize: "14px",
    fontWeight: "500px",
    border: "1px solid #E4E4E7",
    borderRadius: "8px",
  },
}));

export const CustomTooltip = ({
  tooltipText,
  tooltipTitle,
  placement = "top-start",
  ...props
}) => (
  <BootstrapTooltip title={tooltipTitle} arrow placement={placement}>
    {tooltipText ? (
      <Typography
        sx={{
          lineHeight: 1,
        }}
        className="toolTip"
        style={{ fontSize: "14px", color: "#3F3F46", fontFamily: "Inter" }}
      >
        {tooltipText}
      </Typography>
    ) : props.children ? (
      props.children
    ) : (
      <Typography
        className="toolTip"
        style={{ fontSize: "14px", color: "#3F3F46", fontFamily: "Inter" }}
      ></Typography>
    )}
  </BootstrapTooltip>
);

export const CustomChip = ({ label, onDelete, ...props }) => {
  return (
    <Chip
      sx={{
        borderRadius: "4px",
        border: "1px solid #E1E6E2",
        marginRight: "8px",
        height: "24px",
        width: "fit-content",
        color: colors.nc_gray_900,
        ...styles.regular_font,
        ...styles.t7,
        ...props.style,
      }}
      deleteIcon={<img src={chipDeleteIcon} alt="Remove icon" />}
      variant="outlined"
      onMouseDown={(e) => e.stopPropagation()}
      onDelete={onDelete}
      key={props.key || label || "1"}
      label={label}
    />
  );
};
const btnStyle = {
  height: "36px",
  fontSize: "14px",
  lineHeight: "14px",
  fontWeight: "400",
  padding: "10px 16px",
  border: "1px solid lightgray",
};

export const CustomAvatar = ({ name }) => {
  return (
    <Avatar
      sx={{
        bgcolor: "#F7FAF8",
        color: "gray",
        border: "1px solid #E0E0E0",
        marginRight: "10px",
      }}
    >
      {name?.charAt(0)?.toUpperCase()}
    </Avatar>
  );
};

const localStyles = {
  scrollbar: {
    "& ::-webkit-scrollbar": {
      background: "transparent",
      width: "8px",
      opacity: 0,
      height: 0,
    },
    "& ::-webkit-scrollbar-track-piece": {
      background: "transparent",
    },
    "& ::-webkit-scrollbar-thumb": {
      backgroundColor: "transparent",
      width: "8px",
      borderRadius: "3px",
      transition: "all 0.3s ease-in-out",
    },
    "& ::-webkit-scrollbar-track": {
      background: "transparent",
      width: "8px",
    },
    "& ::-webkit-scrollbar-corner": {
      display: "none",
    },
    "& ::-webkit-scrollbar-button": {
      display: "none",
    },
    "& :hover::-webkit-scrollbar-thumb": {
      background: "#c6ccc8",
    },
  },
};

export const ErrorMessage = ({ message }) => {
  if (!message) return null;
  return (
    <p style={{ color: 'indianred' }} className='t7 medium-font'>{message}</p>
  );
};